<template>
  <el-form :inline="true" class="custom-state-form" @submit.native.prevent>
    <el-form-item>
      <div class="el-input-group el-input-group--prepend">
        <div class="el-input-group__prepend">Scope</div>
        <el-select v-model="localState.scope" placeholder="Select">
          <el-option
            v-for="scope in availableScopes"
            :key="scope.id"
            :label="scope.label"
            :value="scope.id"
          />
        </el-select>
      </div>
    </el-form-item>
    <el-form-item>
      <el-input
        class="custom-state-input"
        placeholder="Enter a name"
        :value="localState.label"
        :maxlength="50"
        :disabled="readonly"
        @input="v => updateLabel(v.trim())"
      >
        <template slot="prepend">Name:</template>
      </el-input>
    </el-form-item>
    <el-form-item>
      <el-switch
        :value="localState.value"
        class="md-primary"
        on-text="True"
        on-color="#13ce66"
        off-text="False"
        off-color="#ff4949"
        :width="70"
        :disabled="readonly"
        @input="updateValue"
      />
    </el-form-item>

    <el-form-item>
      <div class="error-message">
        {{ errorMessage || '\u00A0' }}
      </div>
    </el-form-item>

    <input type="submit" style="display: none;">

    <el-form-item class="button-row">
      <el-button type="primary" @click="onApply">{{ applyLabel }}</el-button>
      <el-button @click="onCancel">Cancel</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';

import scopeMixins from '../utils/ScopeMixins';

export default {
  name: 'custom-state-editor',
  mixins: [ scopeMixins ],
  props: {
    caseConf: {
      type: Object,
      default: () => {}
    },
    customState: {
      type: Object,
      default: () => {}
    },
    readonly: {
      type: Boolean,
      required: true,
    },
    applyLabel: {
      type: String,
      default: 'Apply'
    },
  },
  data() {
    return {
      localState: null,
      errorMessage: null,
    };
  },
  computed: {
    availableScopes() {
      return this.getAvailableScopes(this.caseConf);
    },
  },
  watch: {
    customState() {
      this.syncState();
    }
  },
  created() {
    this.syncState();
  },
  methods: {
    syncState() {
      this.localState = cloneDeep(this.customState);
    },
    commonUpdate() {
      this.errorMessage = null;

    },
    updateLabel(label) {
      this.localState.label = label;
      this.commonUpdate();
    },
    updateValue(value) {
      this.localState.value = value;
      this.commonUpdate();
    },
    onApply() {
      if (!this.localState.label) {
        this.errorMessage = 'Enter a name';
        return;
      }
      this.$emit('apply', this.localState);
    },
    onCancel() {
      this.$emit('cancel');
      this.syncState();
    },
  }
}
</script>

<style scoped>
.el-form.custom-state-form.el-form--inline {
  height: auto;
  display: flex;
  flex-direction: column;
}

.el-form-item {
  margin-right: 8px;
  margin-bottom: 8px;
}

.el-form-item:last-child {
  margin-bottom: 0;
  align-self: flex-end;
}

.error-message {
  color: #f92c2d;
  text-align: center;
}
</style>